import React from "react";

const Disclaimer = () => {
  return (
    <div className="bg-amber-50 border-b border-amber-200 rounded-t-lg px-4 py-3 text-xs text-amber-800 flex items-start gap-2">
      <span className="text-amber-500 flex-shrink-0">⚠️</span>
      <p>
        <strong>Disclaimer:</strong> Using DriverSure does not constitute advice
        regarding retention or hiring of employees. No liability will be conferred
        to 4safedrivers.com or any of its affiliates or subsidiaries for any
        employment decisions made, based on information provided on the DriverSure
        site.
      </p>
    </div>
  );
};

export default Disclaimer;
